import React, { Component } from 'react';
import { Form, Button, Radio } from 'antd';

class TypeOfWallet extends Component {
	componentDidMount() {
		const { setFieldsValue } = this.props.form;
		setFieldsValue({ type: 'multi' });
	}

	handleSubmit = () => {
		const { onSubmit } = this.props;
		const { getFieldValue } = this.props.form;
		onSubmit(getFieldValue('type'));
	};
	render() {
		const { getFieldDecorator, getFieldValue } = this.props.form;
		const radioStyle = {
			display: 'flex',
			alignItems: 'top',
			padding: '12px',
			border: '1px solid transparent'
		};
		return (
			<Form>
				<Form.Item>
					{getFieldDecorator('type')(
						<Radio.Group style={{ width: '100%' }}>
							<Radio
								value="multi"
								style={{ ...radioStyle }}
								className={
									getFieldValue('type') === 'multi' ? 'active' : ''
								}
							>
								<div style={{ display: 'inline-block' }}>
									<p>
										<b>Multi Address Wallet</b>
									</p>
									<p style={{ whiteSpace: 'normal' }}>
										Generate multiple address and have your balance
										aggregated under one wallet account. Useful for
										issuing wallets to multiple users.
									</p>
								</div>
							</Radio>
							<Radio
								value="single"
								style={{ ...radioStyle }}
								className={
									getFieldValue('type') === 'single' ? 'active' : ''
								}
							>
								<div style={{ display: 'inline-block' }}>
									<p>
										<b>Single Address Wallet</b>
									</p>
								</div>
							</Radio>
						</Radio.Group>
					)}
				</Form.Item>
				<Button block type="primary" onClick={this.handleSubmit}>
					Next
				</Button>
			</Form>
		);
	}
}

const WrappedTypeOfWallet = Form.create()(TypeOfWallet);

export default WrappedTypeOfWallet;
